export default __webpack_public_path__ + "static/media/clip.60de7ce2.svg";